import { Stage as PixiStage } from '@pixi/react';

export const Stage = ({ children, ...props }: any) => {
  return (
    <PixiStage
      {...props}
      options={{ ...props.options, sortableChildren: true }}
    >
      {children}
    </PixiStage>
  );
};
